<pbc-filter-preset
  [filter]="zeiten.preset$ | async"
  [filters]="zeiten.presets$ | async"
  [name]="zeiten.search$ | async"
  (select)="zeiten.setFilter($event)"
  (save)="zeiten.writeFilter($event)"
  (delete)="zeiten.deleteFilter($event)"
></pbc-filter-preset>
